import axios, {AxiosError} from 'axios';
import {
  ID,
  ErrorObject,
} from 'types';

/**
 * Returns courses array in which such a child is involved
 * @param {ID} id
 * @return {Promise<CourseObject[] | ErrorObject>}
 */
export async function getUsageListItems(id: ID) {
  const url = `${process.env.REACT_APP_API_BASE_URL}/teachers/courses/content-occurrences?childId=${id}`;

  return axios({
    method: 'PATCH',
    url,
  })
    .then((response: any) => response.data)
    .catch((error: AxiosError<ErrorObject>) => (
      error.response?.data
    ));
}

